module.exports = __webpack_public_path__ + "static/StyreneA-Regular-04902089c72d194435aced1d18c2a35b.ttf";